export default "__VITE_ASSET__b2f4c09a__"